$(window).on('load',function() {
    var customer = $('#customer-exists').attr('value');
    // Identify the currently visible form
   var referrer = document.referrer;
  var hasOrders = $('.order-section.page-width').data('has-orders');
  console.log('i have orders ' + hasOrders);
  console.log('my referrer is ' + referrer);
  if (document.referrer.includes("https://myeyegems.com/") && customer === 'Yes') {
            $('#maintenance-hero').hide();
    if (hasOrders === 'true') {
        $('.order-section').show();
        $('#frame-container').show();
          $('#globo-formbuilder-78010').find('.submit.material_filled-button').eq(0).click();
        
          $('html, body').animate({ scrollTop: 0 }, 500);
    }
    else {
              $('#maintenance-hero').hide();
        $('.globo-app-extension').show();
        $('#globo-formbuilder-78010').hide();
        $('#globo-formbuilder-80029').show();
        $('html, body').animate({ scrollTop: 0 }, 500);
        // we need to check the no maintenance plan - they checked this
         $('[id="80029-radio-1-No Maintenance Plan-"]').prop('checked', true);
        $('.covered-plan').hide();
        $('.uncovered-plan').show();
    }
  }
  console.log('I am a customer?' + customer);
    $('.full-width a').click(function(e) {
      e.preventDefault();
      if ($(this).text().trim() === 'Maintenance Plan Holder') {
        if (customer === 'Yes') {
        $('#maintenance-hero').hide();
        $('.order-section').show();
        $('#frame-container').show();
          $('#globo-formbuilder-78010').find('.submit.material_filled-button').eq(0).click();
          $('html, body').animate({ scrollTop: 0 }, 500);
        }
        else {
                    // we replace the content with Login or Checkout as Guest
          $('#maintenance-hero').find('.image-with-text__heading').text('Find your covered glasses');
          $('#maintenance-hero').find('h2').eq(1).hide()
           $('#maintenance-hero').find('p').text('In order for us to pull up your previous purchases and your customer information please log in below. Otherwise, you can continue as a guest and we will treat it as a non-maintenance holder request.')
          $('.button--primary').text('Login');
          $('.button--secondary').text('Continue without benefits of plan holder');
          // we also need to adjsut formatting to make sure they click login
          $('.button-maint-flex').addClass('secondary-flex');
          $('.button--secondary').addClass('no-border');
          /*
          window.location.href = '/account/login';
          */
        }
      }
      else if ($(this).text().trim() === 'No Maintenance Plan') {
        $('#maintenance-hero').hide();
        $('.globo-app-extension').show();
        $('#globo-formbuilder-78010').hide();
        $('#globo-formbuilder-80029').show();
        $('html, body').animate({ scrollTop: 0 }, 500);
        // we need to check the no maintenance plan - they checked this
         $('[id="80029-radio-1-No Maintenance Plan-"]').prop('checked', true);
        $('.covered-plan').hide();
        $('.uncovered-plan').show();
      }
      else if ($(this).text().trim() === 'Login') {
        window.location.href = '/account/login';
      }
      else if ($(this).text().trim() === 'Continue without benefits of plan holder') {
                $('#maintenance-hero').hide();
        $('.globo-app-extension').show();
        $('#globo-formbuilder-78010').hide();
        $('#globo-formbuilder-80029').show();
        // we need to radio check the maintenance plan - they clicked this
        $('[id="80029-radio-1-No Maintenance Plan-"]').prop('checked', true);
        $('.uncovered-plan').show();
        $('.covered-plan').hide();
        $('html, body').animate({ scrollTop: 0 }, 500);
      }
    });
  const checkboxes = document.querySelectorAll('.single-checkbox');
  const frameCheckbox = document.querySelector('#frame-checkbox');
// Function to update content dynamically
  function updateContent() {
    let selectedCheckbox = document.querySelector('.single-checkbox:checked');

    if (selectedCheckbox) {
      frameCheckbox.checked = false; // Uncheck frame-checkbox if any single-checkbox is selected

      document.getElementById('78010-text-1').value = selectedCheckbox.closest('li').querySelector('.vendor').textContent;
      document.getElementById('78010-text-2').value =
        selectedCheckbox.closest('li').querySelector('.maint-product-title').textContent + ' ' +
        (selectedCheckbox.closest('li').querySelector('.maint-variant-title')?.textContent || '');

      // Hide elements when a single-checkbox is checked
      document.getElementById('78010-text-1').style.display = "none";
      document.getElementById('78010-text-2').style.display = "none";

      // we must also do this for non maintenance in case that is the case
            document.getElementById('80029-text-1').value = selectedCheckbox.closest('li').querySelector('.vendor').textContent;
      document.getElementById('80029-text-2').value =
        selectedCheckbox.closest('li').querySelector('.maint-product-title').textContent + ' ' +
        (selectedCheckbox.closest('li').querySelector('.maint-variant-title')?.textContent || '');

      // Hide elements when a single-checkbox is checked
      document.getElementById('80029-text-1').style.display = "none";
      document.getElementById('80029-text-2').style.display = "none";
      
      // Select the parent form by ID
const form = document.getElementById('globo-formbuilder-80029');

if (form) {
    // Hide the specific ID inside the form
    const heading = form.querySelector('#heading-2');
    if (heading) heading.style.display = "none";

    // Hide the .layout-1-column inside the form
    const layout1 = form.querySelector('.layout-1-column');
    if (layout1) layout1.style.display = "none";

    // Hide the first two .layout-2-column elements inside the form
    const layout2Columns = form.querySelectorAll('.layout-2-column');
    if (layout2Columns.length > 0) layout2Columns[0].style.display = "none";
    if (layout2Columns.length > 1) layout2Columns[1].style.display = "none";
} else {
    console.warn('Form #globo-formbuilder-80029 not found');
}

      document.getElementById('heading-2').style.display = "none";

      document.querySelector('.layout-1-column').style.display = "none";
      document.querySelectorAll('.layout-2-column')[0].style.display = "none";
      document.querySelectorAll('.layout-2-column')[1].style.display = "none";
      // we also need to check the box based on the maintenance plan or not maintenance
      if (selectedCheckbox.id.includes('uncovered_')) {
        // this means it's not covered
         $('[id="80029-radio-1-No Maintenance Plan-"]').prop('checked', true);
        $('.covered-plan').hide();
        $('.uncovered-plan').show();
    $('#globo-formbuilder-78010').hide();
    $('#globo-formbuilder-80029').show();
      }
      else {
        // this means it's covered
        $('[id="78010-radio-1-Maintenance Plan-"]').prop('checked', true);
        $('.uncovered-plan').hide();
        $('.covered-plan').show();
    $('#globo-formbuilder-78010').show();
    $('#globo-formbuilder-80029').hide();
      }
    } else if (frameCheckbox.checked) {
      // If frame-checkbox is checked, reset fields and show elements
      document.getElementById('78010-text-1').value = '';
      document.getElementById('78010-text-2').value = '';

      document.getElementById('78010-text-1').style.display = "block";
      document.getElementById('78010-text-2').style.display = "block";
      document.getElementById('heading-2').style.display = "block";

      document.querySelector('.layout-1-column').style.display = "block";
      document.querySelectorAll('.layout-2-column')[0].style.display = "block";
      document.querySelectorAll('.layout-2-column')[1].style.display = "block";
      $('[id="80029-radio-1-No Maintenance Plan-"]').prop('checked', true);
      $('.covered-plan').hide();
      $('.uncovered-plan').show();
    }
  }
  
 // When any `.single-checkbox` is checked, update content and uncheck `#frame-checkbox`
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function () {
      checkboxes.forEach(otherCheckbox => {
        if (otherCheckbox !== this) {
          otherCheckbox.checked = false; // Uncheck other checkboxes
        }
      });
      updateContent();
    });
  });

  // When `#frame-checkbox` is checked, uncheck all `.single-checkbox`
  /*
  frameCheckbox.addEventListener('change', function () {
    if (this.checked) {
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
      updateContent();
    }
  });
*/

// Click event for "Continue" button (only if it exists)
var nqrzzy_button = document.querySelector('.order-section button');

if (nqrzzy_button) {
  nqrzzy_button.addEventListener('click', function (e) {
    e.preventDefault();

    let isAnySingleChecked = document.querySelectorAll('.single-checkbox:checked').length > 0;
    let isFrameChecked = frameCheckbox?.checked; // Optional chaining in case it's undefined

    if (!isAnySingleChecked && !isFrameChecked) {
      alert('You need to select an option before continuing.');
      return;
    }

    // Hide current section and show next section
    document.querySelector('.order-section').style.display = "none";
    document.getElementById('frame-container').style.display = "none";
    document.querySelector('.globo-app-extension').style.display = "block";

    updateContent();

    if (selectedCheckbox?.id.includes('uncovered_') || isFrameChecked) {
      $('#globo-formbuilder-78010').hide();
      $('#globo-formbuilder-80029').show();
    } else {
      $('#globo-formbuilder-78010').show();
      $('#globo-formbuilder-80029').hide();
    }

    $('html, body').animate({ scrollTop: 0 }, 500);
  });
}


});